export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a className='navbar-brand page-scroll' href='#page-top'>
            <img alt="logo" src="img/logo.png" height="40px"/>
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#about' className='page-scroll'>
              公司簡介
              </a>
            </li>
            <li>
              <a href='#services' className='page-scroll'>
              服務項目
              </a>
            </li>
            <li>
              <a href='#portfolio' className='page-scroll'>
                車款
              </a>
            </li>
            <li>
              <a href='#portfolio2' className='page-scroll'>
                形象影片
              </a>
            </li>
            <li>
              <a href='#features' className='page-scroll'>
              租車流程
              </a>
            </li>
            <li>
              <a href='#contact' className='page-scroll'>
                聯絡我們
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
